"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Triangle = void 0;
const Adapt_1 = require("../../modifiers/Adapt");
const ShapeBuffer_1 = require("../ShapeBuffer");
/**
 * Triangle ShapeBuffer
 *
 * @category Shapes.ShapeBuffer
 */
class Triangle extends ShapeBuffer_1.ShapeBuffer {
    /**
     * Creates an instance of Triangleeee.
     *
     * @param {ShapeBaseSettings} [settings={}]
     * @memberof Triangle
     */
    constructor(settings = {}) {
        settings.type = 'Triangle';
        settings.shape = Triangle.buffer;
        settings.adaptMode = Adapt_1.EAdaptMode.None;
        super(settings);
    }
}
exports.Triangle = Triangle;
Triangle.buffer = [1, 0, -1, 1, -1, -1];
//# sourceMappingURL=Triangle.js.map